import { render, staticRenderFns } from "./PlacementCreateStep.vue?vue&type=template&id=a06d6f04"
import script from "./PlacementCreateStep.vue?vue&type=script&lang=js"
export * from "./PlacementCreateStep.vue?vue&type=script&lang=js"
import style0 from "./PlacementCreateStep.vue?vue&type=style&index=0&id=a06d6f04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports